import React from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  /** Content to render in the portal */
  children: React.ReactNode;
  /** Target container element (defaults to document.body) */
  container?: Element;
}

/**
 * Portal — renders children into a DOM node outside the parent React tree.
 *
 * Used by: Modal, Drawer, Tooltip, Popover, Popconfirm, Message, Notification, Dropdown.
 *
 * @example
 * <Portal>
 *   <div>I render at document.body</div>
 * </Portal>
 *
 * <Portal container={myRef.current}>
 *   <div>I render inside a custom container</div>
 * </Portal>
 */
export function Portal({ children, container }: PortalProps) {
  return createPortal(children, container ?? document.body);
}
